import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LAYOUT_TYPE_FULL, NAV_STYLE_FIXED, THEME_TYPE_SEMI_DARK } from "../../constants/ApplicationConstants/ThemeSetting";
import type { Locale } from "../../shared/types/locale.type";

interface SettingsState {
  navStyle: string;
  layoutType: string;
  themeType: string;
  themeColor: string;
  isDirectionRTL: boolean;
  locale: Locale;
}

const initialState: SettingsState = {
  navStyle: NAV_STYLE_FIXED,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  themeColor: "",
  isDirectionRTL: false,
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us"
  }
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    clearReduxStore() {
      return initialState;
    },
    updateThemeType(state, action: PayloadAction<string>) {
      state.themeType = action.payload;
    },
    updateThemeColor(state, action: PayloadAction<string>) {
      state.themeColor = action.payload;
    },
    updateRtlStatus(state, action: PayloadAction<boolean>) {
      state.isDirectionRTL = action.payload;
    },
    updateNavStyle(state, action: PayloadAction<string>) {
      state.navStyle = action.payload;
    },
    updateLayoutType(state, action: PayloadAction<string>) {
      state.layoutType = action.payload;
    },
    switchLanguage(state, action: PayloadAction<Locale>) {
      state.locale = action.payload;
    }
  }
});

export const { clearReduxStore, updateThemeType, updateThemeColor, updateRtlStatus, updateNavStyle, updateLayoutType, switchLanguage } = settingsSlice.actions;

export default settingsSlice.reducer;
